import { Component, OnInit } from '@angular/core';
import { ErrorService } from '../../tools/error.service';
import { IxellAPIService, ErrorLogV1, LogV1, ILogLacourEditV1 } from '../../tools/api.service';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Constants } from '../../entities/Constants';
import { HeaderService } from '../../tools/header.service';


@Component({
    selector: 'app-monitoringInterne',
    templateUrl: './monitoringInterne.component.html',
    styleUrls: ['./monitoringInterne.component.scss']
})
export class MonitoringInterneComponent implements OnInit {
    getLogLacourEditSub: any;
    rewindLogLacourEditSub: any;
    getErrorLogSub: any;
    getLogSub: any;
    getLogAccesClientSub: any;
    exportLogAccesClientSub: any;
    logLacourEditLst: ILogLacourEditV1[][] = [];
    errorLst: ErrorLogV1[] = [];
    errorSource: any;
    logLst: LogV1[] = [];
    logSource: any;
    logAccesLst: LogV1[] = [];
    logAccesClientSource: any;

    showLogLacourEdit: boolean = true;
    showErrorLog: boolean = false;
    showLog: boolean = false;
    showLogAccesClient: boolean = false;
    displayedColumns0 = ["errorCode", "errorDate", "errorDescription", "errorParameters"];
    displayedColumns1 = ["logId", "logDate", "logCategorie", "logSouscategorie", "logEvenement", "logInfos", "logLogin"];
    displayedColumns2 = ["logId", "logDate", "logCategorie", "logSouscategorie", "logEvenement", "logInfos", "logLogin"];
    displayedColumns: string[];

    rewindMessage: string = "";
    nbDays: number = 7;


    constructor(private errorService: ErrorService, private apiService: IxellAPIService, private headerService: HeaderService) { }

    ngOnInit() {

        this.headerService.changeLogo(null);
        this.headerService.changeCanBack(true);
        //this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeTitle("Monitoring Interne - Logs Modifs Lacour");
        this.showLogLacourEditData();
    }

    getNbDays(): number {
        if (this.nbDays < 1)
            return 1;
        return this.nbDays;
    }

    getStartDate(): Date {
        return new Date((new Date()).getTime() - (this.getNbDays() * 24 * 60 * 60 * 1000))
    }

    refresh() {
        if (this.showLogLacourEdit)
            this.showLogLacourEditData();
        else if (this.showErrorLog)
            this.showErrorLogData();
        else if (this.showLog)
            this.showLogData();
        else if (this.showLogAccesClient)
            this.showLogAccesClientData();
    }

    showLogLacourEditData() {
        this.headerService.changeTitle("Monitoring Interne - Logs Modifs Lacour");
        document.getElementById("btnLogLacourEdit").setAttribute("disabled", "disabled");
        document.getElementById("btnLog").setAttribute("disabled", "disabled");
        document.getElementById("btnErrorLog").setAttribute("disabled", "disabled");
        document.getElementById("btnLogAccesClient").setAttribute("disabled", "disabled");
        this.showLogLacourEdit = true;
        this.showErrorLog = false;
        this.showLog = false;
        this.showLogAccesClient = false;
        this.displayedColumns = null;
        this.getLogLacourEditSub = this.apiService.getLogLacourEdit(this.getStartDate()).subscribe(data => {
            this.logLacourEditLst = data.map(d => d.reverse()).reverse();
            document.getElementById("btnLogLacourEdit").removeAttribute("disabled");
            document.getElementById("btnLog").removeAttribute("disabled");
            document.getElementById("btnErrorLog").removeAttribute("disabled");
            document.getElementById("btnLogAccesClient").removeAttribute("disabled");
            if (this.getLogLacourEditSub != null) this.getLogLacourEditSub.unsubscribe();
        }, error => {
            if (this.getLogLacourEditSub != null) this.getLogLacourEditSub.unsubscribe();
        });
    }

    showErrorLogData() {
        this.headerService.changeTitle("Monitoring Interne - Error Log");
        document.getElementById("btnLogLacourEdit").setAttribute("disabled", "disabled");
        document.getElementById("btnLog").setAttribute("disabled", "disabled");
        document.getElementById("btnErrorLog").setAttribute("disabled", "disabled");
        document.getElementById("btnLogAccesClient").setAttribute("disabled", "disabled");
        this.showLogLacourEdit = false;
        this.showErrorLog = true;
        this.showLog = false;
        this.showLogAccesClient = false;
        this.displayedColumns = null;
        this.getErrorLogSub = this.apiService.selectErrorLog(this.getStartDate()).subscribe(data => {
            this.errorLst = data;
            this.errorSource = new MatTableDataSource(this.errorLst);
            this.displayedColumns = this.displayedColumns0;
            document.getElementById("btnLogLacourEdit").removeAttribute("disabled");
            document.getElementById("btnLog").removeAttribute("disabled");
            document.getElementById("btnErrorLog").removeAttribute("disabled");
            document.getElementById("btnLogAccesClient").removeAttribute("disabled");
        }, error => {
            console.log(error);
            if (this.getErrorLogSub != null) this.getErrorLogSub.unsubscribe();
        });
    }

    showLogData() {
        this.headerService.changeTitle("Monitoring Interne - Log");
        document.getElementById("btnLogLacourEdit").setAttribute("disabled", "disabled");
        document.getElementById("btnLog").setAttribute("disabled", "disabled");
        document.getElementById("btnErrorLog").setAttribute("disabled", "disabled");
        document.getElementById("btnLogAccesClient").setAttribute("disabled", "disabled");
        this.showLogLacourEdit = false;
        this.showErrorLog = false;
        this.showLog = true;
        this.showLogAccesClient = false;
        this.displayedColumns = null;
        this.getLogSub = this.apiService.selectLog(this.getStartDate()).subscribe(data => {
            data.forEach(element => {
                var logDateUTC = new Date(Date.UTC(element.logDate.getFullYear(), element.logDate.getMonth(), element.logDate.getDate(), element.logDate.getHours(), element.logDate.getMinutes()));
                element.logDate = logDateUTC;
            })
            this.logLst = data;
            this.logSource = new MatTableDataSource(this.logLst);
            this.displayedColumns = this.displayedColumns1;
            this.showErrorLog = false;
            this.showLog = true;
            this.showLogAccesClient = false;
            document.getElementById("btnLogLacourEdit").removeAttribute("disabled");
            document.getElementById("btnLog").removeAttribute("disabled");
            document.getElementById("btnErrorLog").removeAttribute("disabled");
            document.getElementById("btnLogAccesClient").removeAttribute("disabled");
        }, error => {
            console.log(error);
            if (this.getLogSub != null) this.getLogSub.unsubscribe();
        });
    }

    showLogAccesClientData() {
        this.headerService.changeTitle("Monitoring Interne - Log accès client");
        document.getElementById("btnLogLacourEdit").setAttribute("disabled", "disabled");
        document.getElementById("btnLog").setAttribute("disabled", "disabled");
        document.getElementById("btnErrorLog").setAttribute("disabled", "disabled");
        document.getElementById("btnLogAccesClient").setAttribute("disabled", "disabled");
        this.showLogLacourEdit = false;
        this.showErrorLog = false;
        this.showLog = false;
        this.showLogAccesClient = true;
        this.displayedColumns = null;
        this.getLogAccesClientSub = this.apiService.selectLogAccesClient(this.getStartDate()).subscribe(data => {
            this.logAccesLst = data;
            this.logAccesClientSource = new MatTableDataSource(this.logAccesLst);
            this.displayedColumns = this.displayedColumns2;
            this.showErrorLog = false;
            this.showLog = false;
            this.showLogAccesClient = true;
            document.getElementById("btnLogLacourEdit").removeAttribute("disabled");
            document.getElementById("btnLog").removeAttribute("disabled");
            document.getElementById("btnErrorLog").removeAttribute("disabled");
            document.getElementById("btnLogAccesClient").removeAttribute("disabled");
        }, error => {
            console.log(error);
            if (this.getLogAccesClientSub != null) this.getLogAccesClientSub.unsubscribe();
        });
    }

    sortScale(sort: Sort, status: string) {
        var data = this.errorLst;
        Constants.sortScale(sort, status, data);
        this.errorLst = data.slice();
    }

    applyFilter(filterValue: string, source: string) {
        if (source == 'errorLog') this.errorSource.filter = filterValue.trim().toLowerCase();
        else if (source == 'log') this.logSource.filter = filterValue.trim().toLowerCase();
        else if (source == 'logAccesClient') this.logAccesClientSource.filter = filterValue.trim().toLowerCase();
    }

    getProperDate(date: string): string {
        const nDate = new Date(date);
        return nDate.toLocaleDateString() + ' ' + nDate.toLocaleTimeString()
    }

    getProperValue(valueName: string, pKey: number) {
        const valueDetail = valueName.split('_');
        switch (valueDetail[0]) {
            case 'BillingDetail':
            {
                switch (valueDetail[1]) {
                    case 'ADDPROD':
                        return `Ajout du produit ${pKey} (pour formulaire de location)`;
                    case 'UPDPROD':
                        return `Mise à jour de la quantité du produit ${pKey}`;
                    case 'DELPROD':
                        return `Suppression du produit ${pKey}`;
                }
                break;
            }
            case 'Activation':
            {
                switch (valueDetail[1]) {
                    case 'CTCID':
                        return `Changement du CTC de l'activation ${pKey}`;
                    case 'USERUSERID':
                        return `Changement de l'utilisateur associé à l'activation ${pKey}`;
                    case 'PAYORUSERID':
                        return `Changement du payeur associé à l'activation ${pKey}`;
                    case 'USERCOMPANYID':
                        return `Changement de la compagnie associé à l'activation ${pKey}`;
                    case 'PAYORCOMPANYID':
                        return `Changement de la compagnie payeuse associé à l'activation ${pKey}`;
                    case 'ACTIVCODE':
                        return `Changement du code de l'activation ${pKey}`;
                    case 'SCALEID':
                        return `Changement de la balance associée à l'activation ${pKey}`;
                }
                break;
            }
            case 'User':
            {
                switch (valueDetail[1]) {
                    case 'UNISITECODE':
                        return `Changement du code Unisite de l'utilisateur ${pKey}`;
                    case 'EMAIL':
                        return `Changement de l'email de l'utilisateur ${pKey}`;
                }
                break;
            }
            case 'Company':
            {
                switch (valueDetail[1]) {
                    case 'SOCIALREASON':
                        return `Changement de la raison sociale de la compagnie ${pKey}`;
                    case 'ADDRESS':
                        return `Changement de l'adresse de la compagnie ${pKey}`;
                    case 'POSTALCODE':
                        return `Changement du code postal de la compagnie ${pKey}`;
                    case 'CITY':
                        return `Changement de la ville de la compagnie ${pKey}`;
                    case 'COUNTRY':
                        return `Changement du pays de la compagnie ${pKey}`;
                    case 'UNISITECODE':
                        return `Changement du code Unisite de la compagnie ${pKey}`;
                    case 'SIREN':
                        return `Changement de SIREN de la compagnie ${pKey}`;
                    case 'SIRET':
                        return `Changement de SIRET de la compagnie ${pKey}`;
                    case 'TVA':
                        return `Changement du N° de TVA Intracommunautaire de la compagnie ${pKey}`;
                }
                break;
            }
            case 'Scale':
            {
                switch (valueDetail[1]) {
                    case 'STARTDATE':
                        return `Changement de la date de début de licence de la balance ${pKey}`;
                    case 'ENDDATE':
                        return `Changement de la date de fin de licence de la balance ${pKey}`;
                }
                break;
            }
            case 'Renting':
            {
                switch (valueDetail[1]) {
                    case 'CTCID':
                        return `Changement du CTC du formulaire de location ${pKey}`;
                    case 'IXELLACCOUNT':
                        return `Changement du N° compte Ixell du formulaire de location ${pKey}`;
                    case 'CUSTOMERSTATUS':
                        return `Changement du Tarif du formulaire de location ${pKey}`;
                    case 'TECHNOLOGY':
                        return `Changement de la technologie du formulaire de location ${pKey}`;
                    case 'COMPANYTYPE':
                        return `Changement du type de l'appartenance du client du formulaire de location ${pKey}`;
                    case 'COMPANYTYPENAME':
                        return `Changement du nom de l'appartenance du client du formulaire de location ${pKey}`;
                    case 'LEADER':
                        return `Changement du dirigeant de la société associée au formulaire de location ${pKey}`;
                    case 'BODYSHOPINTERLOCUTOR':
                        return `Changement de l'interlocuteur carrosserie de la société associée au formulaire de location ${pKey}`;
                    case 'COMPANYPHONE':
                        return `Changement du téléphone de la société associée au formulaire de location ${pKey}`;
                    case 'COMPANYMAIL':
                        return `Changement de l'e-mail de la société associée au formulaire de location ${pKey}`;
                    case 'COMPANYDIRECTLIGN':
                        return `Changement de la ligne directe de la société associée au formulaire de location ${pKey}`;
                }
                break;
            }
        }

        return `${valueName} - ${pKey}`;
    }

    rewind(logLacourEditID: number) {
        this.rewindLogLacourEditSub = this.apiService.rewindLogLacourEdit(logLacourEditID).subscribe(data => {
            if (data === 0)
                this.showLogLacourEditData();
            else {
                switch (data) {
                    case -1:
                        this.rewindMessage = 'Erreur BDD';
                        break;
                    case -2:
                        this.rewindMessage = 'La valeur du/des élément(s) à rétablir ont changé depuis la création du/des log(s).\r\nVous ne pouvez donc pas l\'/les annuler.';
                        break;
                    default:
                        this.rewindMessage = `Une erreur est survenue (${data})`;
                        break;
                }

                document.getElementById('errorLogLacourRewindModal').style.display = 'block';
            }
            
            if (this.rewindLogLacourEditSub != null) this.rewindLogLacourEditSub.unsubscribe();
        }, error => {
            if (this.rewindLogLacourEditSub != null) this.rewindLogLacourEditSub.unsubscribe();
        });
    }

    closeModal(id: string) {
        document.getElementById(id).style.display = 'none';
    }

    ExportLogAccesClient() {
        this.exportLogAccesClientSub = this.apiService.exportLogAccesClient(this.getStartDate()).subscribe(data => {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(data.data);
            element.download = "Log Acces Client";
            document.body.appendChild(element);
            element.click();
        }, error => {
            console.log(error);
            if (this.exportLogAccesClientSub != null) this.exportLogAccesClientSub.unsubscribe();
        });
    }

    ngOnDestroy() {
        if (this.getLogLacourEditSub != null) this.getLogLacourEditSub.unsubscribe();
        if (this.rewindLogLacourEditSub != null) this.rewindLogLacourEditSub.unsubscribe();
        if (this.getErrorLogSub != null) this.getErrorLogSub.unsubscribe();
        if (this.getLogSub != null) this.getLogSub.unsubscribe();
        if (this.getLogAccesClientSub != null) this.getLogAccesClientSub.unsubscribe();
        if (this.exportLogAccesClientSub != null) this.exportLogAccesClientSub.unsubscribe();
    }
}
